// @ts-nocheck
// Email translations - 10 languages
export const EMAIL_I18N: Record<string, Record<string, string>> = {
  en: {
    checkInSubject: '✅ CHECK-IN COMPLETED',
    checkOutSubject: '☠ CHECK-OUT COMPLETED',
    checkOutDmgSubject: '⚠ CHECK-OUT WITH DAMAGES',
    yacht: 'YACHT', skipper: 'SKIPPER', phone: 'PHONE', email: 'EMAIL',
    mode: 'MODE', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Agreements', completeInventory: 'Complete Inventory',
    damageReport: 'DAMAGE REPORT',
    importantNotice: 'IMPORTANT NOTICE – MANDATORY READING',
    item: 'ITEM', page: 'PAGE', total: 'TOTAL', rate: 'RATE', unitPrice: 'UNIT PRICE',
    netTotal: 'NET TOTAL:', totalWithVat: 'TOTAL WITH VAT:',
    skipperSig: "Skipper's Signature", employeeSig: "Employee's Signature",
    paymentAuth: 'Payment Authorization *',
    checkInReport: 'Check-in Report – Page 5', checkOutReport: 'Check-out Report – Page 5',
    thankYou: 'Thank you in advance.',
    documentGenerated: 'Document generated on',
    warningText1: "If check-in is completed by the company's specialized staff, signed by the customer and the check-in manager, and no damage or clogging is detected on the yacht",
    warningHighlight: '(if there is any damage, the base manager is obliged to report it so that the customer knows, writes it in the comments and takes a photo)',
    warningText2: 'or toilet clogging, the company and the base have no responsibility after check-in.',
    warningText3: 'The customer upon return must pay for the damage without any excuse. The customer is responsible for any damage after check-in. They must take care of the vessel and return it in the condition they received it.',
    warningTextShort: 'If check-in is completed and no damage or toilet clogging is detected, the company and base have no responsibility after check-in.',
    bookingDetails: 'Booking Details',
    notes: 'Notes',
    cardReleaseTitle: 'Card Release',
    cardReleaseText: 'No damage was found on the yacht. The customer consents to the release of the pre-authorization held on their card.',
    cardReleaseAccept: 'No damage found — release card',
    thankYouNoDamage: 'After the check-out inspection, no damage was found on the yacht by the base staff. Thank you very much for choosing Tailwind for your holidays. Have a safe return.',
    contactOfficeDamage: 'The yacht was found with the damages listed above. Please contact the office to settle the payment. Thank you very much. — The Tailwind staff',
    paymentRequiredTitle: 'PAYMENT REQUIRED FOR DAMAGES',
    thankYouTitle: 'THANK YOU',
  },
  el: {
    checkInSubject: '✅ CHECK-IN ΟΛΟΚΛΗΡΩΘΗΚΕ',
    checkOutSubject: '☠ CHECK-OUT ΟΛΟΚΛΗΡΩΘΗΚΕ',
    checkOutDmgSubject: '⚠ CHECK-OUT ΜΕ ΖΗΜΙΕΣ',
    yacht: 'ΣΚΑΦΟΣ', skipper: 'ΚΥΒΕΡΝΗΤΗΣ', phone: 'ΤΗΛΕΦΩΝΟ', email: 'EMAIL',
    mode: 'ΛΕΙΤΟΥΡΓΙΑ', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Συμφωνίες', completeInventory: 'Πλήρες Ινβεντάριο',
    damageReport: 'ΑΝΑΦΟΡΑ ΖΗΜΙΩΝ',
    importantNotice: 'ΣΗΜΑΝΤΙΚΗ ΕΙΔΟΠΟΙΗΣΗ – ΥΠΟΧΡΕΩΤΙΚΗ ΑΝΑΓΝΩΣΗ',
    item: 'ΕΙΔΟΣ', page: 'ΣΕΛΙΔΑ', total: 'ΣΥΝΟΛΟ', rate: 'ΤΙΜΗ', unitPrice: 'ΤΙΜΗ ΜΟΝΑΔΑΣ',
    netTotal: 'ΚΑΘΑΡΟ ΣΥΝΟΛΟ:', totalWithVat: 'ΣΥΝΟΛΟ ΜΕ ΦΠΑ:',
    skipperSig: 'Υπογραφή Κυβερνήτη', employeeSig: 'Υπογραφή Υπαλλήλου',
    paymentAuth: 'Εξουσιοδότηση Πληρωμής *',
    checkInReport: 'Αναφορά Check-in – Σελίδα 5', checkOutReport: 'Αναφορά Check-out – Σελίδα 5',
    thankYou: 'Ευχαριστούμε εκ των προτέρων.',
    documentGenerated: 'Έγγραφο δημιουργήθηκε στις',
    warningText1: 'Εάν γίνει check-in από το εξειδικευμένο προσωπικό της εταιρίας, υπογράψει ο πελάτης και ο υπεύθυνος του check-in, και δεν διαπιστωθεί καμία ζημιά στο σκάφος',
    warningHighlight: '(εάν υπάρχει κάποια ζημιά υποχρεούται να το πει ο υπεύθυνος της βάσης ώστε ο πελάτης να το γνωρίζει, να το γράψει στα σχόλια και να βγάλει φωτογραφία)',
    warningText2: 'ή βούλωμα στην τουαλέτα, η εταιρία και η βάση δεν έχουν καμία ευθύνη μετά το check-in.',
    warningText3: 'Ο πελάτης στην επιστροφή θα πρέπει να πληρώσει την ζημιά χωρίς καμία δικαιολογία. Ο πελάτης είναι υπεύθυνος για οποιαδήποτε ζημιά γίνει μετά το check-in. Θα πρέπει να φροντίζει το σκάφος και να το παραδώσει στην κατάσταση που το πήρε.',
    warningTextShort: 'Εάν γίνει check-in και δεν διαπιστωθεί ζημιά ή βούλωμα τουαλέτας, η εταιρία και η βάση δεν έχουν καμία ευθύνη μετά το check-in.',
    bookingDetails: 'Στοιχεία Κράτησης',
    notes: 'Σημειώσεις',
    cardReleaseTitle: 'Απελευθέρωση Κάρτας',
    cardReleaseText: 'Δεν διαπιστώθηκε καμία ζημιά στο σκάφος. Ο πελάτης συναινεί στην απελευθέρωση της προέγκρισης που κρατείται στην κάρτα του.',
    cardReleaseAccept: 'Δεν βρέθηκε ζημιά — απελευθέρωση κάρτας',
    thankYouNoDamage: 'Μετά τον έλεγχο του check-out, δεν διαπιστώθηκε καμία ζημιά στο σκάφος από το προσωπικό της βάσης. Σας ευχαριστούμε πολύ που προτιμήσατε την Tailwind για τις διακοπές σας. Καλή επιστροφή.',
    contactOfficeDamage: 'Το σκάφος βρέθηκε με τις ζημιές που αναφέρονται παραπάνω. Παρακαλούμε επικοινωνήστε με το γραφείο για τη διευθέτηση της πληρωμής. Σας ευχαριστούμε πολύ. — Το προσωπικό της Tailwind',
    paymentRequiredTitle: 'ΑΠΑΙΤΕΙΤΑΙ ΠΛΗΡΩΜΗ ΓΙΑ ΖΗΜΙΕΣ',
    thankYouTitle: 'ΕΥΧΑΡΙΣΤΟΥΜΕ',
  },
  it: {
    checkInSubject: '✅ CHECK-IN COMPLETATO',
    checkOutSubject: '☠ CHECK-OUT COMPLETATO',
    checkOutDmgSubject: '⚠ CHECK-OUT CON DANNI',
    yacht: 'YACHT', skipper: 'SKIPPER', phone: 'TELEFONO', email: 'EMAIL',
    mode: 'MODALITÀ', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Accordi', completeInventory: 'Inventario Completo',
    damageReport: 'RAPPORTO DANNI',
    importantNotice: 'AVVISO IMPORTANTE – LETTURA OBBLIGATORIA',
    item: 'ARTICOLO', page: 'PAGINA', total: 'TOTALE', rate: 'TARIFFA', unitPrice: 'PREZZO UNITARIO',
    netTotal: 'TOTALE NETTO:', totalWithVat: 'TOTALE CON IVA:',
    skipperSig: 'Firma dello Skipper', employeeSig: 'Firma del Dipendente',
    paymentAuth: 'Autorizzazione al Pagamento *',
    checkInReport: 'Rapporto Check-in – Pagina 5', checkOutReport: 'Rapporto Check-out – Pagina 5',
    thankYou: 'Grazie in anticipo.',
    documentGenerated: 'Documento generato il',
    warningText1: "Se il check-in viene completato dal personale specializzato dell'azienda, firmato dal cliente e dal responsabile del check-in, e non vengono rilevati danni o intasamenti sullo yacht",
    warningHighlight: "(in caso di danni, il responsabile della base è obbligato a segnalarlo affinché il cliente ne sia informato, a scriverlo nei commenti e a scattare una foto)",
    warningText2: "o intasamento del WC, l'azienda e la base non hanno alcuna responsabilità dopo il check-in.",
    warningText3: "Il cliente al rientro dovrà pagare il danno senza alcuna giustificazione. Il cliente è responsabile di qualsiasi danno dopo il check-in. Deve prendersi cura dell'imbarcazione e restituirla nelle condizioni in cui l'ha ricevuta.",
    warningTextShort: "Se il check-in viene completato e non vengono rilevati danni o intasamenti del WC, l'azienda e la base non hanno alcuna responsabilità dopo il check-in.",
    bookingDetails: 'Dettagli Prenotazione',
    notes: 'Note',
  },
  de: {
    checkInSubject: '✅ CHECK-IN ABGESCHLOSSEN',
    checkOutSubject: '☠ CHECK-OUT ABGESCHLOSSEN',
    checkOutDmgSubject: '⚠ CHECK-OUT MIT SCHÄDEN',
    yacht: 'YACHT', skipper: 'SKIPPER', phone: 'TELEFON', email: 'EMAIL',
    mode: 'MODUS', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Vereinbarungen', completeInventory: 'Vollständiges Inventar',
    damageReport: 'SCHADENSBERICHT',
    importantNotice: 'WICHTIGER HINWEIS – PFLICHTLEKTÜRE',
    item: 'ARTIKEL', page: 'SEITE', total: 'GESAMT', rate: 'PREIS', unitPrice: 'STÜCKPREIS',
    netTotal: 'NETTO GESAMT:', totalWithVat: 'GESAMT MIT MWST:',
    skipperSig: 'Unterschrift des Skippers', employeeSig: 'Unterschrift des Mitarbeiters',
    paymentAuth: 'Zahlungsermächtigung *',
    checkInReport: 'Check-in Bericht – Seite 5', checkOutReport: 'Check-out Bericht – Seite 5',
    thankYou: 'Vielen Dank im Voraus.',
    documentGenerated: 'Dokument erstellt am',
    warningText1: 'Wenn das Check-in vom spezialisierten Personal des Unternehmens durchgeführt, vom Kunden und dem Check-in-Manager unterschrieben wird und keine Schäden oder Verstopfungen an der Yacht festgestellt werden',
    warningHighlight: '(bei Schäden ist der Basismanager verpflichtet, dies zu melden, damit der Kunde informiert ist, es in die Kommentare zu schreiben und ein Foto zu machen)',
    warningText2: 'oder Toilettenverstopfung, haben das Unternehmen und die Basis nach dem Check-in keine Verantwortung.',
    warningText3: 'Der Kunde muss bei der Rückgabe den Schaden ohne Ausrede bezahlen. Der Kunde ist für jeden Schaden nach dem Check-in verantwortlich. Er muss sich um das Schiff kümmern und es im gleichen Zustand zurückgeben.',
    warningTextShort: 'Wenn das Check-in abgeschlossen ist und keine Schäden oder Toilettenverstopfungen festgestellt werden, haben das Unternehmen und die Basis nach dem Check-in keine Verantwortung.',
    bookingDetails: 'Buchungsdetails',
    notes: 'Anmerkungen',
  },
  ru: {
    checkInSubject: '✅ CHECK-IN ЗАВЕРШЁН',
    checkOutSubject: '☠ CHECK-OUT ЗАВЕРШЁН',
    checkOutDmgSubject: '⚠ CHECK-OUT С ПОВРЕЖДЕНИЯМИ',
    yacht: 'ЯХТА', skipper: 'ШКИПЕР', phone: 'ТЕЛЕФОН', email: 'EMAIL',
    mode: 'РЕЖИМ', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Соглашения', completeInventory: 'Полная Инвентаризация',
    damageReport: 'ОТЧЁТ О ПОВРЕЖДЕНИЯХ',
    importantNotice: 'ВАЖНОЕ УВЕДОМЛЕНИЕ – ОБЯЗАТЕЛЬНО К ПРОЧТЕНИЮ',
    item: 'ПРЕДМЕТ', page: 'СТРАНИЦА', total: 'ИТОГО', rate: 'ЦЕНА', unitPrice: 'ЦЕНА ЗА ЕД.',
    netTotal: 'ИТОГО НЕТТО:', totalWithVat: 'ИТОГО С НДС:',
    skipperSig: 'Подпись Шкипера', employeeSig: 'Подпись Сотрудника',
    paymentAuth: 'Авторизация Платежа *',
    checkInReport: 'Отчёт Check-in – Страница 5', checkOutReport: 'Отчёт Check-out – Страница 5',
    thankYou: 'Заранее благодарим.',
    documentGenerated: 'Документ создан',
    warningText1: 'Если check-in выполнен специализированным персоналом компании, подписан клиентом и менеджером check-in, и на яхте не обнаружено повреждений или засоров',
    warningHighlight: '(при наличии повреждений менеджер базы обязан сообщить об этом клиенту, записать в комментарии и сделать фотографию)',
    warningText2: 'или засор унитаза, компания и база не несут ответственности после check-in.',
    warningText3: 'Клиент при возврате обязан оплатить ущерб без каких-либо оправданий. Клиент несёт ответственность за любые повреждения после check-in. Он должен заботиться о судне и вернуть его в том же состоянии.',
    warningTextShort: 'Если check-in завершён и не обнаружено повреждений или засоров, компания и база не несут ответственности после check-in.',
    bookingDetails: 'Данные Бронирования',
    notes: 'Примечания',
  },
  fr: {
    checkInSubject: '✅ CHECK-IN TERMINÉ',
    checkOutSubject: '☠ CHECK-OUT TERMINÉ',
    checkOutDmgSubject: '⚠ CHECK-OUT AVEC DOMMAGES',
    yacht: 'YACHT', skipper: 'SKIPPER', phone: 'TÉLÉPHONE', email: 'EMAIL',
    mode: 'MODE', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Accords', completeInventory: 'Inventaire Complet',
    damageReport: 'RAPPORT DE DOMMAGES',
    importantNotice: 'AVIS IMPORTANT – LECTURE OBLIGATOIRE',
    item: 'ARTICLE', page: 'PAGE', total: 'TOTAL', rate: 'TARIF', unitPrice: 'PRIX UNITAIRE',
    netTotal: 'TOTAL NET:', totalWithVat: 'TOTAL TTC:',
    skipperSig: 'Signature du Skipper', employeeSig: "Signature de l'Employé",
    paymentAuth: 'Autorisation de Paiement *',
    checkInReport: 'Rapport Check-in – Page 5', checkOutReport: 'Rapport Check-out – Page 5',
    thankYou: "Merci d'avance.",
    documentGenerated: 'Document généré le',
    warningText1: "Si le check-in est effectué par le personnel spécialisé de l'entreprise, signé par le client et le responsable du check-in, et qu'aucun dommage ou obstruction n'est détecté sur le yacht",
    warningHighlight: "(en cas de dommage, le responsable de la base est tenu de le signaler afin que le client en soit informé, de l'écrire dans les commentaires et de prendre une photo)",
    warningText2: "ou obstruction des toilettes, l'entreprise et la base n'ont aucune responsabilité après le check-in.",
    warningText3: "Le client au retour devra payer les dommages sans aucune excuse. Le client est responsable de tout dommage après le check-in. Il doit prendre soin du navire et le rendre dans l'état où il l'a reçu.",
    warningTextShort: "Si le check-in est terminé et qu'aucun dommage ou obstruction n'est détecté, l'entreprise et la base n'ont aucune responsabilité après le check-in.",
    bookingDetails: 'Détails de Réservation',
    notes: 'Notes',
  },
  ro: {
    checkInSubject: '✅ CHECK-IN FINALIZAT',
    checkOutSubject: '☠ CHECK-OUT FINALIZAT',
    checkOutDmgSubject: '⚠ CHECK-OUT CU DAUNE',
    yacht: 'IAHT', skipper: 'SKIPPER', phone: 'TELEFON', email: 'EMAIL',
    mode: 'MOD', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Acorduri', completeInventory: 'Inventar Complet',
    damageReport: 'RAPORT DAUNE',
    importantNotice: 'NOTIFICARE IMPORTANTĂ – CITIRE OBLIGATORIE',
    item: 'ARTICOL', page: 'PAGINĂ', total: 'TOTAL', rate: 'PREȚ', unitPrice: 'PREȚ UNITAR',
    netTotal: 'TOTAL NET:', totalWithVat: 'TOTAL CU TVA:',
    skipperSig: 'Semnătura Skipperului', employeeSig: 'Semnătura Angajatului',
    paymentAuth: 'Autorizare de Plată *',
    checkInReport: 'Raport Check-in – Pagina 5', checkOutReport: 'Raport Check-out – Pagina 5',
    thankYou: 'Vă mulțumim anticipat.',
    documentGenerated: 'Document generat la',
    warningText1: 'Dacă check-in-ul este efectuat de personalul specializat al companiei, semnat de client și managerul de check-in, și nu se detectează daune sau blocaje pe iaht',
    warningHighlight: '(dacă există daune, managerul bazei este obligat să le raporteze astfel încât clientul să fie informat, să le scrie în comentarii și să facă o fotografie)',
    warningText2: 'sau blocaj la toaletă, compania și baza nu au nicio responsabilitate după check-in.',
    warningText3: 'Clientul la returnare trebuie să plătească daunele fără nicio scuză. Clientul este responsabil pentru orice daună după check-in. Trebuie să aibă grijă de vas și să îl returneze în starea în care l-a primit.',
    warningTextShort: 'Dacă check-in-ul este finalizat și nu se detectează daune sau blocaje, compania și baza nu au nicio responsabilitate după check-in.',
    bookingDetails: 'Detalii Rezervare',
    notes: 'Note',
  },
  pl: {
    checkInSubject: '✅ CHECK-IN ZAKOŃCZONY',
    checkOutSubject: '☠ CHECK-OUT ZAKOŃCZONY',
    checkOutDmgSubject: '⚠ CHECK-OUT Z USZKODZENIAMI',
    yacht: 'JACHT', skipper: 'SKIPPER', phone: 'TELEFON', email: 'EMAIL',
    mode: 'TRYB', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Umowy', completeInventory: 'Pełny Inwentarz',
    damageReport: 'RAPORT SZKÓD',
    importantNotice: 'WAŻNA INFORMACJA – LEKTURA OBOWIĄZKOWA',
    item: 'PRZEDMIOT', page: 'STRONA', total: 'RAZEM', rate: 'CENA', unitPrice: 'CENA JEDN.',
    netTotal: 'RAZEM NETTO:', totalWithVat: 'RAZEM Z VAT:',
    skipperSig: 'Podpis Skippera', employeeSig: 'Podpis Pracownika',
    paymentAuth: 'Autoryzacja Płatności *',
    checkInReport: 'Raport Check-in – Strona 5', checkOutReport: 'Raport Check-out – Strona 5',
    thankYou: 'Dziękujemy z góry.',
    documentGenerated: 'Dokument wygenerowany',
    warningText1: 'Jeśli check-in zostanie przeprowadzony przez wyspecjalizowany personel firmy, podpisany przez klienta i kierownika check-in, i nie zostaną wykryte żadne uszkodzenia lub zatory na jachcie',
    warningHighlight: '(w przypadku uszkodzeń kierownik bazy jest zobowiązany zgłosić to klientowi, wpisać w komentarze i zrobić zdjęcie)',
    warningText2: 'lub zator toalety, firma i baza nie ponoszą odpowiedzialności po check-in.',
    warningText3: 'Klient przy zwrocie musi zapłacić za szkodę bez żadnych wymówek. Klient jest odpowiedzialny za wszelkie szkody po check-in. Musi dbać o statek i zwrócić go w stanie, w jakim go otrzymał.',
    warningTextShort: 'Jeśli check-in jest zakończony i nie wykryto uszkodzeń lub zatorów, firma i baza nie ponoszą odpowiedzialności po check-in.',
    bookingDetails: 'Szczegóły Rezerwacji',
    notes: 'Uwagi',
  },
  he: {
    checkInSubject: '✅ CHECK-IN הושלם',
    checkOutSubject: '☠ CHECK-OUT הושלם',
    checkOutDmgSubject: '⚠ CHECK-OUT עם נזקים',
    yacht: 'יאכטה', skipper: 'סקיפר', phone: 'טלפון', email: 'EMAIL',
    mode: 'מצב', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'הסכמות', completeInventory: 'מלאי מלא',
    damageReport: 'דוח נזקים',
    importantNotice: 'הודעה חשובה – קריאה חובה',
    item: 'פריט', page: 'עמוד', total: 'סה"כ', rate: 'מחיר', unitPrice: 'מחיר ליחידה',
    netTotal: 'סה"כ נטו:', totalWithVat: 'סה"כ כולל מע"מ:',
    skipperSig: 'חתימת הסקיפר', employeeSig: 'חתימת העובד',
    paymentAuth: 'אישור תשלום *',
    checkInReport: 'דוח Check-in – עמוד 5', checkOutReport: 'דוח Check-out – עמוד 5',
    thankYou: 'תודה מראש.',
    documentGenerated: 'מסמך נוצר בתאריך',
    warningText1: 'אם ה-check-in הושלם על ידי הצוות המקצועי של החברה, נחתם על ידי הלקוח ומנהל ה-check-in, ולא זוהו נזקים או סתימות ביאכטה',
    warningHighlight: '(אם יש נזק, מנהל הבסיס מחויב לדווח על כך כדי שהלקוח יידע, לרשום בהערות ולצלם תמונה)',
    warningText2: 'או סתימת שירותים, לחברה ולבסיס אין שום אחריות לאחר ה-check-in.',
    warningText3: 'הלקוח בהחזרה חייב לשלם על הנזק ללא כל תירוץ. הלקוח אחראי לכל נזק לאחר ה-check-in. עליו לטפל בכלי השיט ולהחזירו במצב שקיבל אותו.',
    warningTextShort: 'אם ה-check-in הושלם ולא זוהו נזקים או סתימות, לחברה ולבסיס אין שום אחריות לאחר ה-check-in.',
    bookingDetails: 'פרטי הזמנה',
    notes: 'הערות',
  },
  es: {
    checkInSubject: '✅ CHECK-IN COMPLETADO',
    checkOutSubject: '☠ CHECK-OUT COMPLETADO',
    checkOutDmgSubject: '⚠ CHECK-OUT CON DAÑOS',
    yacht: 'YATE', skipper: 'PATRÓN', phone: 'TELÉFONO', email: 'EMAIL',
    mode: 'MODO', checkInH: 'CHECK-IN', checkOutH: 'CHECK-OUT',
    agreements: 'Acuerdos', completeInventory: 'Inventario Completo',
    damageReport: 'INFORME DE DAÑOS',
    importantNotice: 'AVISO IMPORTANTE – LECTURA OBLIGATORIA',
    item: 'ARTÍCULO', page: 'PÁGINA', total: 'TOTAL', rate: 'TARIFA', unitPrice: 'PRECIO UNITARIO',
    netTotal: 'TOTAL NETO:', totalWithVat: 'TOTAL CON IVA:',
    skipperSig: 'Firma del Patrón', employeeSig: 'Firma del Empleado',
    paymentAuth: 'Autorización de Pago *',
    checkInReport: 'Informe Check-in – Página 5', checkOutReport: 'Informe Check-out – Página 5',
    thankYou: 'Gracias de antemano.',
    documentGenerated: 'Documento generado el',
    warningText1: 'Si el check-in es realizado por el personal especializado de la empresa, firmado por el cliente y el responsable del check-in, y no se detectan daños ni atascos en el yate',
    warningHighlight: '(si hay algún daño, el responsable de la base está obligado a informarlo para que el cliente lo sepa, escribirlo en los comentarios y tomar una foto)',
    warningText2: 'o atasco del inodoro, la empresa y la base no tienen responsabilidad después del check-in.',
    warningText3: 'El cliente en la devolución deberá pagar el daño sin ninguna excusa. El cliente es responsable de cualquier daño después del check-in. Debe cuidar la embarcación y devolverla en el estado en que la recibió.',
    warningTextShort: 'Si el check-in se completa y no se detectan daños ni atascos, la empresa y la base no tienen responsabilidad después del check-in.',
    bookingDetails: 'Detalles de Reserva',
    notes: 'Notas',
  },
};

export function getEmailLabels(lang: string): Record<string, string> {
  return EMAIL_I18N[lang] || EMAIL_I18N.en;
}
